<template>
  <div>
    <el-dialog :visible.sync="editShow" :title="commData.comm">
      <el-form
        :model="commData"
        label-width="120px"
        ref="editform"
        :rules="rules"
      >
        <el-form-item label="波特率">
          <el-select size="mini" class="input" v-model="commData.baudrate">
            <el-option
              v-for="i in baudrateList"
              :label="i"
              :value="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据位">
          <el-input
            class="input"
            v-if="dataBitsInputShow"
            v-model="dataBitsInputValue"
            @blur="dataBitsInputBlur"
            size="mini"
          ></el-input>
          <el-select
            v-model="commData.data_bits"
            size="mini"
            class="input"
            @change="dataBitsChange"
            v-else
          >
            <el-option
              v-for="i in dataBitsList"
              :label="i"
              :value="i"
            ></el-option>
            <el-option label="--自定义--" value=""></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="停止位">
          <el-input
            class="input"
            v-if="stopBitsInputShow"
            v-model="stopBitsInputValue"
            @blur="stopBitsInputBlur"
            size="mini"
          ></el-input>
          <el-select
            v-model="commData.stop_bits"
            size="mini"
            class="input"
            @change="stopBitsChange"
            v-else
          >
            <el-option
              v-for="i in stopBitsList"
              :label="i"
              :value="i"
            ></el-option>
            <el-option label="--自定义--" value=""></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="校验位">
          <el-select size="mini" v-model="commData.parity" class="input">
            <el-option label="Space" value="S"></el-option>
            <el-option label="Even" value="E"></el-option>
            <el-option label="Mask" value="M"></el-option>
            <el-option label="Odd" value="O"></el-option>
            <el-option label="None" value="N"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="流控">
          <el-select size="mini" v-model="commData.flow_ctrl" class="input">
            <el-option label="None" value="N"></el-option>
            <el-option label="RTS/CTS" value="R"></el-option>
            <el-option label="XON/XOFF" value="X"></el-option>
            <el-option label="DTR/DSR" value="D"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="启用分包">
          <el-checkbox v-model="commData.enable_frame"></el-checkbox>
        </el-form-item>
        <el-form-item label="分包间隔" prop="timeout">
          <el-input
            size="mini"
            class="input"
            v-model="commData.timeout"
          ></el-input>
        </el-form-item>
        <el-form-item label="分包长度" prop="frame_len">
          <el-input
            size="mini"
            class="input"
            v-model="commData.frame_len"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item>
            <el-button size="mini" type="danger">保存并应用</el-button>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editShow = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "edit",
  props: ["commData"],
  data() {
    var checkNumber = (rule, value, callback) => {
      if (!isNaN(Number(value))) {
        callback();
      } else {
        callback(new Error("请输入正确的数值"));
      }
    };
    return {
      editShow: false,
      baudrateList: [
        "115200",
        "57600",
        "38400",
        "19200",
        "9600",
        "4800",
        "2400",
        "1800",
        "1200",
        "600",
        "300",
        "200",
        "150",
        "134",
        "110",
      ],
      dataBitsList: ["6", "7", "8"],
      dataBitsInputShow: false,
      dataBitsInputValue: "",
      stopBitsList: ["1", "2"],
      stopBitsInputShow: false,
      stopBitsInputValue: "",
      rules: {
        timeout: [
          { required: true, message: "请输入分包间隔", trigger: "blur" },
          { validator: checkNumber, trigger: "blur" },
        ],
        frame_len: [
          { required: true, message: "请输入分包长度", trigger: "blur" },
          { validator: checkNumber, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    dataBitsChange(e) {
      // console.log(e);
      if (!e) {
        this.dataBitsInputShow = true;
      }
    },
    stopBitsChange(e) {
      if (!e) {
        this.dataBitsInputShow = true;
      }
    },
    dataBitsInputBlur() {
      if (this.dataBitsList.includes(this.dataBitsInputValue)) {
        this.dataBitsInputShow = false;
        this.commData.data_bits = this.dataBitsInputValue;
        this.dataBitsInputValue = "";
      } else {
        this.dataBitsList.push(this.dataBitsInputValue);
        this.dataBitsInputShow = false;
        this.commData.data_bits = this.dataBitsInputValue;
        this.dataBitsInputValue = "";
      }
    },
    stopBitsInputBlur() {
      if (this.dataBitsList.includes(this.stopBitsInputValue)) {
        this.stopBitsInputShow = false;
        this.commData.stop_bits = this.stopBitsInputValue;
        this.stopBitsInputValue = "";
      } else {
        this.dataBitsList.push(this.stopBitsInputValue);
        this.stopBitsInputShow = false;
        this.commData.stop_bits = this.stopBitsInputValue;
        this.stopBitsInputValue = "";
      }
    },
    confirm() {
      this.$refs["editform"].validate((v) => {
        if (v) {
          this.editShow = false;
        } else {
          this.$message({
            type:"warning",
            message:"请先完善表单"
          })
        }
      });
    },
  },
};
</script>
<style scoped>
.input {
  width: 240px;
}
</style>
